{
  "not_available_in_mock": "Deze pagina is helaas niet beschikbaar in deze demo-versie. Ga naar het <link>overzicht met verkiezingen</link> om andere functionaliteit uit te proberen."
}
